// ROCKSTAR - rockstar Database
// Contains all rockstars (real + decoys) with names, alternate names, sources, and whether they're in the image
// inImage: true = rockstar is in the collection image
// inImage: false = decoy rockstar (not in image, triggers penalty)

// GAME CONFIGURATION
const gameConfig = {
    // Main game identity
    gameTitle: "ROCKSTAR",
    subjectPlural: "rockstars",        // "robots", "aliens", "rockstars", etc.
    subjectSingular: "rockstar",       // "robot", "alien", "rockstar", etc.
    subjectCapPlural: "ROCKSTARS",     // "ROBOTS", "ALIENS", "ROCKSTARS", etc.
    subjectCapSingular: "ROCKSTAR",    // "ROBOT", "ALIEN", "ROCKSTAR", etc.
    
    // Calculated from database (will be set programmatically)
    totalCount: 26,
    
    // UI Text Templates
    subtitle: "FIND {count} FAMOUS {subjects}",
    instructionsTop: "Study the {subject} silhouettes and enter their names below...",
    instructionsBottom: "Type at least three characters and options will appear. Select from the list or hit return to enter your guess. Beware: some options are decoys. Find all <strong>{count}</strong> {subjects} to win! Use the links at the end to post your score.",
    
    // Game mechanics
    revealThresholdPercent: 75,
    
    // Messages
    correctMessage: "🎯 Correct! {name} identified!",
    notInCollectionMessage: "❌ {name} is not in the collection.",
    alreadyFoundMessage: "You already found {name}!",
    missionCompleteMessage: "🎉 MISSION COMPLETE! All {subjects} found!",
    revealUnlockMessage: "You've found {percent}% of {subjects} - Reveal option unlocked!",
    revealProgressMessage: "Find {threshold}% of {subjects} to unlock Reveal option (currently {percent}%)",
    quitUnlockMessage: "Find {threshold}% of {subjects} to unlock Reveal option",
    
    // Share text templates
    shareText: "{accuracy}% accuracy - found {found} of {total} {subjects} in {title}! Can you beat me?",
    shareCallToAction: "Can you find all {total} {subjects}?",
    
    // URLs
    gameUrl: "https://www.chopshopstore.com/pages/rockstar-game",
    shopBaseUrl: "https://www.chopshopstore.com"
};

const rockstarDatabase = [
    // ===== rockstars IN THE IMAGE (inImage: true) =====
        
    //IN THE GAME
    
    // Roger Daltrey & The Who
    { name: "Roger Daltrey", officialName: "Roger Daltrey", source: "The Who", inImage: true },
    { name: "John Entwhistle", officialName: "John Entwistle", source: "The Who", inImage: false },
    { name: "John Entwistle", officialName: "John Entwistle", source: "The Who", inImage: false },
    { name: "Keith Moon", officialName: "Keith Moon", source: "The Who", inImage: false },
    
    // Elton John
    { name: "Elton John", officialName: "Elton John", source: "Elton John", inImage: true },
    { name: "Reginald Dwight", officialName: "Elton John", source: "Elton John", inImage: true },
    
    // Pete Townshend (see previous Who entry)
    { name: "Pete Townshend", officialName: "Pete Townshend", source: "The Who", inImage: true },
    
    // Mick Jagger and the Stones
    { name: "Mick Jagger", officialName: "Mick Jagger", source: "Rolling Stones", inImage: true },
    { name: "Michael Philip Jagger", officialName: "Mick Jagger", source: "Rolling Stones", inImage: true },
    { name: "Michael Jagger", officialName: "Mick Jagger", source: "Rolling Stones", inImage: true },
    { name: "Mike Jagger", officialName: "Mick Jagger", source: "Rolling Stones", inImage: true },
    { name: "Ron Wood", officialName: "Ron Wood", source: "Rolling Stones", inImage: false },
    { name: "Ronny Wood", officialName: "Ron Wood", source: "Rolling Stones", inImage: false },
    { name: "Charlie Watts", officialName: "Charlie Watts", source: "Rolling Stones", inImage: false },
    { name: "Charles Watts", officialName: "Charlie Watts", source: "Rolling Stones", inImage: false },
    { name: "Brian Jones", officialName: "Brian Jones", source: "Rolling Stones", inImage: false },
    { name: "Bill Wyman", officialName: "Bill Wyman", source: "Rolling Stones", inImage: false },
    
    // Jimmi Hendrix
    { name: "Jimi Hendrix", officialName: "Jimi Hendrix", source: "Jimi Hendrix & the Experience", inImage: true },
    { name: "Jimmi Hendrix", officialName: "Jimi Hendrix", source: "Jimi Hendrix & the Experience", inImage: true },
    { name: "Jimmy Hendrix", officialName: "Jimi Hendrix", source: "Jimi Hendrix & the Experience", inImage: true },
    { name: "James Hendrix", officialName: "Jimi Hendrix", source: "Jimi Hendrix & the Experience", inImage: true },
    { name: "Johnny Hendrix", officialName: "Jimi Hendrix", source: "Jimi Hendrix & the Experience", inImage: true },
    
    // Duane Allman
    { name: "Duane Allman", officialName: "Duane Allman", source: "Allman Brothers", inImage: true },
    { name: "Gregg Allman", officialName: "Gregg Allman", source: "Allman Brothers", inImage: false },
    { name: "Dickey Betts", officialName: "Dickey Betts", source: "Allman Brothers", inImage: false },
    
    // Roger Waters
    { name: "Roger Waters", officialName: "Roger Waters", source: "Pink Floyd", inImage: true },
    { name: "George Waters", officialName: "Roger Waters", source: "Pink Floyd", inImage: true },
    { name: "David Gilmour", officialName: "David Gilmour", source: "Pink Floyd", inImage: false },
    { name: "Dave Gilmour", officialName: "David Gilmour", source: "Pink Floyd", inImage: false },
    { name: "Syd Barrett", officialName: "Syd Barrett", source: "Pink Floyd", inImage: false },
    
    // Janis Joplin
    { name: "Janis Joplin", officialName: "Janis Joplin", source: "Janis Joplin", inImage: true },
    { name: "Janice Joplin", officialName: "Janis Joplin", source: "Janis Joplin", inImage: true },
    
    // George Harrison and the Beatles, see the rest below
    { name: "George Harrison", officialName: "George Harrison", source: "The Beatles", inImage: true },
    { name: "Ringo Starr", officialName: "Ringo Starr", source: "The Beatles", inImage: false },
    
    // Lou Reed 
    { name: "Lou Reed", officialName: "Lou Reed", source: "Velvet Underground", inImage: true },
    { name: "Lewis Reed", officialName: "Lou Reed", source: "Velvet Underground", inImage: true },
    { name: "Louis Reed", officialName: "Lou Reed", source: "Velvet Underground", inImage: true },
    { name: "John Cale", officialName: "John Cale", source: "Velvet Underground", inImage: false },
    
    // Bob Dylan
    { name: "Bob Dylan", officialName: "Bob Dylan", source: "Bob Dylan", inImage: true },
    { name: "Robert Zimmerman", officialName: "Bob Dylan", source: "Bob Dylan", inImage: true },
    { name: "Bob Zimmerman", officialName: "Bob Dylan", source: "Bob Dylan", inImage: true },
    
    // Freddie Mercury
    { name: "Freddie Mercury", officialName: "Freddie Mercury", source: "Queen", inImage: true },
    { name: "Fred Mercury", officialName: "Freddie Mercury", source: "Queen", inImage: true },
    { name: "Farrokh Bulsara", officialName: "Freddie Mercury", source: "Queen", inImage: true },
    
    // Neil Young
    { name: "Neil Young", officialName: "Neil Young", source: "Neil Young", inImage: true },
    { name: "Neil Young", officialName: "Neil Young", source: "Buffalo Springfield", inImage: true },
    
    // Angus Young
    { name: "Angus Young", officialName: "Angus Young", source: "AC-DC", inImage: true },
    
    // Robert Plant and Led Zeppelin
    { name: "Robert Plant", officialName: "Robert Plant", source: "Led Zeppelin", inImage: true },
    { name: "Rob Plant", officialName: "Robert Plant", source: "Led Zeppelin", inImage: true },
    { name: "John Bonham", officialName: "John Bonham", source: "Led Zeppelin", inImage: false },
    { name: "John Paul Jones", officialName: "John Paul Jones", source: "Led Zeppelin", inImage: false },
    { name: "John Jones", officialName: "John Paul Jones", source: "Led Zeppelin", inImage: false },
    
    // Jimmy Page (see above)
    { name: "Jimmy Page", officialName: "Jimmy Page", source: "Led Zeppelin", inImage: true },
    { name: "James Page", officialName: "Jimmy Page", source: "Led Zeppelin", inImage: true },
    { name: "Jim Page", officialName: "Jimmy Page", source: "Led Zeppelin", inImage: true },
    
    // Paul McCartney
    { name: "Paul McCartney", officialName: "Paul McCartney", source: "The Beatles", inImage: true },
    { name: "James Paul McCartney", officialName: "Paul McCartney", source: "The Beatles", inImage: true },
    
    // Eric Clapton
    { name: "Eric Clapton", officialName: "Eric Clapton", source: "Eric Clapton", inImage: true },
    { name: "Slowhand", officialName: "Eric Clapton", source: "Eric Clapton", inImage: true },
    
    // John Lennon
    { name: "John Lennon", officialName: "John Lennon", source: "The Beatles", inImage: true },
    { name: "John Winston Lennon", officialName: "John Lennon", source: "The Beatles", inImage: true },
    { name: "John Ono Lennon", officialName: "John Lennon", source: "The Beatles", inImage: true },
    { name: "Yoko Ono", officialName: "Yoko Ono", source: "The Beatles", inImage: false },
    
    // Ray Davies
    { name: "Ray Davies", officialName: "Ray Davies", source: "The Kinks", inImage: true },
    { name: "Raymond Davies", officialName: "Ray Davies", source: "The Kinks", inImage: true },
    
    // David Bowie
    { name: "David Bowie", officialName: "David Bowie", source: "David Bowie", inImage: true },
    { name: "David Jones", officialName: "David Bowie", source: "David Bowie", inImage: true },
    { name: "Ziggy Stardust", officialName: "David Bowie", source: "David Bowie", inImage: true },
    
    // T-Rex
    { name: "T-Rex", officialName: "Marc Bolan", source: "T-Rex", inImage: true },
    { name: "Trex", officialName: "Marc Bolan", source: "T-Rex", inImage: true },
    { name: "Marc Bolan", officialName: "Marc Bolan", source: "T-Rex", inImage: true },
    { name: "Mark Bolan", officialName: "Marc Bolan", source: "T-Rex", inImage: true },
    { name: "Mark Feld", officialName: "Marc Bolan", source: "T-Rex", inImage: true },
    
    // Jim Morrison
    { name: "Jim Morrison", officialName: "Jim Morrison", source: "The Doors", inImage: true },
    { name: "James Morrison", officialName: "Jim Morrison", source: "The Doors", inImage: true },
    { name: "Jimmy Morrison", officialName: "Jim Morrison", source: "The Doors", inImage: true },
    { name: "Mr. Mojo Risin", officialName: "Jim Morrison", source: "The Doors", inImage: true },
    { name: "Robby Krieger", officialName: "Robby Krieger", source: "The Doors", inImage: false },
    { name: "Robbie Krieger", officialName: "Robby Krieger", source: "The Doors", inImage: false },
    { name: "Rob Krieger", officialName: "Robby Krieger", source: "The Doors", inImage: false },
    { name: "Ray Manzarek", officialName: "Ray Manzarek", source: "The Doors", inImage: false },
    { name: "Raymond Manzarek", officialName: "Ray Manzarek", source: "The Doors", inImage: false },
    { name: "John Densmore", officialName: "John Densmore", source: "The Doors", inImage: false },
    
    // Paul Simon
    { name: "Paul Simon", officialName: "Paul Simon", source: "Simon & Garfunkel", inImage: true },
    { name: "Art Garfunkel", officialName: "Art Garfunkel", source: "Simon & Garfunkel", inImage: false },
    { name: "Art Garfunkle", officialName: "Art Garfunkel", source: "Simon & Garfunkel", inImage: false },
    
    // Keith Richards (see previous Stones entry)
    { name: "Keith Richards", officialName: "Keith Richards", source: "Rolling Stones", inImage: true },
    
    // Van Morrison
    { name: "Van Morrison", officialName: "Van Morrison", source: "Van Morrison", inImage: true },
    { name: "George Morrison", officialName: "Van Morrison", source: "Van Morrison", inImage: true },
    { name: "George Ivan Morrison", officialName: "Van Morrison", source: "Van Morrison", inImage: true },
    
    // Jerry Garcia
    { name: "Jerry Garcia", officialName: "Jerry Garcia", source: "The Grateful Dead", inImage: true },
    { name: "Jerome Garcia", officialName: "Jerry Garcia", source: "The Grateful Dead", inImage: true },
    { name: "Bob Weir", officialName: "Bob Weir", source: "The Grateful Dead", inImage: false },
    { name: "Phil Lesh", officialName: "Phil Lesh", source: "The Grateful Dead", inImage: false },
    
    // Stevie Nicks
    { name: "Stevie Nicks", officialName: "Stevie Nicks", source: "Fleetwood Mac", inImage: true },
    { name: "Stevie Knicks", officialName: "Stevie Nicks", source: "Fleetwood Mac", inImage: true },
    { name: "Stephanie Nicks", officialName: "Stevie Nicks", source: "Fleetwood Mac", inImage: true },
    { name: "Lindsey Buckingham", officialName: "Lindsey Buckingham", source: "Fleetwood Mac", inImage: false },
    { name: "Lindsay Buckingham", officialName: "Lindsey Buckingham", source: "Fleetwood Mac", inImage: false },
    { name: "Christine McVie", officialName: "Christine McVie", source: "Fleetwood Mac", inImage: false },
    
// ===== ADDITIONAL DECOY rockstars =====

    // decoy names 
    { name: "Leonard Cohen", officialName: "Leonard Cohen", source: "Leonard Cohen", inImage: false },
    { name: "Tom Waits", officialName: "Tom Waits", source: "Tom Waits", inImage: false },
    { name: "Joni Mitchell", officialName: "Joni Mitchell", source: "Joni Mitchell", inImage: false },
    { name: "Bill Medley", officialName: "Bill Medley", source: "The Righteous Brothers", inImage: false },
    { name: "Richard Thompson", officialName: "Richard Thompson", source: "Fairport Convention", inImage: false },
    { name: "Sandy Denny", officialName: "Richard Thompson", source: "Fairport Convention", inImage: false },
    { name: "John Sebastian", officialName: "John Sebastian", source: "Lovin Spoonful", inImage: false },
    { name: "Mary Travers", officialName: "Mary Travers", source: "Peter, Paul and Mary", inImage: false },
    { name: "Peter Yarrow", officialName: "Peter Yarrow", source: "Peter, Paul and Mary", inImage: false },
    { name: "Paul Stookey", officialName: "Paul Stookey", source: "Peter, Paul and Mary", inImage: false },
    { name: "John Philips", officialName: "John Phillips", source: "Mamas & the Papas", inImage: false },
    { name: "John Phillips", officialName: "John Phillips", source: "Mamas & the Papas", inImage: false },
    { name: "Tiny Tim", officialName: "Tiny Tim", source: "Tiny Tim", inImage: false },
    { name: "Roger McGuinn", officialName: "Roger McGuinn", source: "The Byrds", inImage: false },
    { name: "Gram Parsons", officialName: "Gram Parsons", source: "Flying Burrito Brothers", inImage: false },
    { name: "Gram Parsons", officialName: "Gram Parsons", source: "The Byrds", inImage: false },
    { name: "Terry Kath", officialName: "Terry Kath", source: "Chicago", inImage: false },
    { name: "Robbie Robertson", officialName: "Robbie Robertson", source: "The Band", inImage: false },
    { name: "Levon Helm", officialName: "Levon Helm", source: "The Band", inImage: false },
    { name: "Stevie Ray Vaughan", officialName: "Stevie Ray Vaughan", source: "Stevie Ray Vaughan", inImage: false },
    { name: "Stevie Ray Vaughn", officialName: "Stevie Ray Vaughan", source: "Stevie Ray Vaughan", inImage: false },
    { name: "Joan Baez", officialName: "Joan Baez", source: "Joan Baez", inImage: false },
    { name: "Donovan", officialName: "Donovan", source: "Donovan", inImage: false },
    { name: "Cat Stevens", officialName: "Cat Stevens", source: "Cat Stevens", inImage: false },
    { name: "Otis Redding", officialName: "Otis Redding", source: "Otis Redding", inImage: false },
    { name: "Joe Cocker", officialName: "Joe Cocker", source: "Joe Cocker", inImage: false },
    { name: "Dave Davies", officialName: "Dave Davies", source: "The Kinks", inImage: false },
    { name: "Sly Stone", officialName: "Sly Stone", source: "Sly and the Family Stone", inImage: false },
    { name: "Carlos Santana", officialName: "Carlos Santana", source: "Santana", inImage: false },
    { name: "Ronnie Van Zant", officialName: "Ronnie Van Zant", source: "Lynyrd Skynyrd", inImage: false },
    { name: "Alice Cooper", officialName: "Alice Cooper", source: "Alice Cooper", inImage: false },
    { name: "Paul Kantner", officialName: "Paul Kantner", source: "Jefferson Airplane", inImage: false },
    { name: "Alvin Lee", officialName: "Alvin Lee", source: "Ten Years After", inImage: false },
    { name: "Phil Collins", officialName: "Phil Collins", source: "Genesis", inImage: false },
    { name: "Peter Gabriel", officialName: "Peter Gabriel", source: "Genesis", inImage: false },
    { name: "Robert Fripp", officialName: "Robert Fripp", source: "King Crimson", inImage: false },
    { name: "Ritchie Blackmore", officialName: "Ritchie Blackmore", source: "Deep Purple", inImage: false },
    { name: "Iggy Pop", officialName: "Iggy Pop", source: "Iggy Pop", inImage: false },
    { name: "Frank Zappa", officialName: "Frank Zappa", source: "Mothers of Invention", inImage: false },
    { name: "David Crosby", officialName: "David Crosby", source: "Crosby, Stills & Nash", inImage: false },
    { name: "Stephen Stills", officialName: "Stephen Stills", source: "Crosby, Stills & Nash", inImage: false },
    { name: "Stephen Stills", officialName: "Stephen Stills", source: "Buffalo Springfield", inImage: false },
    { name: "Steven Stills", officialName: "Stephen Stills", source: "Crosby, Stills & Nash", inImage: false },
    { name: "Graham Nash", officialName: "Graham Nash", source: "Crosby, Stills & Nash", inImage: false },
    { name: "Grace Slick", officialName: "Grace Slick", source: "Jefferson Airplane", inImage: false },
    { name: "John Fogerty", officialName: "John Fogerty", source: "Creedence Clearwater Revival", inImage: false },
    { name: "Ian Anderson", officialName: "Ian Anderson", source: "Jethro Tull", inImage: false },
    { name: "Jon Anderson", officialName: "Jon Anderson", source: "Yes", inImage: false },
    { name: "Rick Wakeman", officialName: "Rick Wakeman", source: "Yes", inImage: false },
    { name: "Steve Winwood", officialName: "Steve Winwood", source: "Traffic", inImage: false },
    { name: "Ravi Shankar", officialName: "Ravi Shankar", source: "Ravi Shankar", inImage: false },
    { name: "Ginger Baker", officialName: "Ginger Baker", source: "Cream", inImage: false },
    { name: "Jack Bruce", officialName: "Jack Bruce", source: "Cream", inImage: false },
    { name: "Jeff Beck", officialName: "Jeff Beck", source: "Yardbirds", inImage: false },
    { name: "Ozzy Osbourne", officialName: "Ozzy Osbourne", source: "Black Sabbath", inImage: false },
    { name: "Rod Stewart", officialName: "Rod Stewart", source: "Faces", inImage: false },
    { name: "James Taylor", officialName: "James Taylor", source: "James Taylor", inImage: false },
    { name: "Slash", officialName: "Slash", source: "Guns and Roses", inImage: false },

    // 1973-1982 classic/heartland rock decoys
    { name: "Bruce Springsteen", officialName: "Bruce Springsteen", source: "Bruce Springsteen & the E Street Band", inImage: false },
    { name: "Tom Petty", officialName: "Tom Petty", source: "Tom Petty and the Heartbreakers", inImage: false },
    { name: "Bob Seger", officialName: "Bob Seger", source: "Bob Seger & the Silver Bullet Band", inImage: false },
    { name: "Billy Joel", officialName: "Billy Joel", source: "Billy Joel", inImage: false },
    { name: "Meat Loaf", officialName: "Meat Loaf", source: "Meat Loaf", inImage: false },
    { name: "Warren Zevon", officialName: "Warren Zevon", source: "Warren Zevon", inImage: false },
    { name: "Steve Miller", officialName: "Steve Miller", source: "Steve Miller Band", inImage: false },
    { name: "Don Henley", officialName: "Don Henley", source: "Eagles", inImage: false },
    { name: "Phil Lynott", officialName: "Phil Lynott", source: "Thin Lizzy", inImage: false },
    { name: "David Lee Roth", officialName: "David Lee Roth", source: "Van Halen", inImage: false },
    { name: "Steve Perry", officialName: "Steve Perry", source: "Journey", inImage: false },
    { name: "Ann Wilson", officialName: "Ann Wilson", source: "Heart", inImage: false },
    { name: "Ted Nugent", officialName: "Ted Nugent", source: "Ted Nugent", inImage: false },
    { name: "Glenn Frey", officialName: "Glenn Frey", source: "Eagles", inImage: false },
    { name: "Joe Walsh", officialName: "Joe Walsh", source: "Eagles", inImage: false },
    { name: "Peter Frampton", officialName: "Peter Frampton", source: "Peter Frampton", inImage: false },
    { name: "Eddie Van Halen", officialName: "Eddie Van Halen", source: "Van Halen", inImage: false },
    { name: "Nancy Wilson", officialName: "Nancy Wilson", source: "Heart", inImage: false },
    { name: "Dennis DeYoung", officialName: "Dennis DeYoung", source: "Styx", inImage: false },
    { name: "Kevin Cronin", officialName: "Kevin Cronin", source: "REO Speedwagon", inImage: false },
    { name: "Lou Gramm", officialName: "Lou Gramm", source: "Foreigner", inImage: false },
    { name: "Pat Benatar", officialName: "Pat Benatar", source: "Pat Benatar", inImage: false },
    { name: "George Thorogood", officialName: "George Thorogood", source: "George Thorogood and the Destroyers", inImage: false },

    // Post-1982 classic/blues-rock feel decoys
    { name: "Axl Rose", officialName: "Axl Rose", source: "Guns N' Roses", inImage: false },
    { name: "Jon Bon Jovi", officialName: "Jon Bon Jovi", source: "Bon Jovi", inImage: false },
    { name: "Lenny Kravitz", officialName: "Lenny Kravitz", source: "Lenny Kravitz", inImage: false },
    { name: "Chris Robinson", officialName: "Chris Robinson", source: "The Black Crowes", inImage: false },
    { name: "Zakk Wylde", officialName: "Zakk Wylde", source: "Black Label Society", inImage: false },
    { name: "Sebastian Bach", officialName: "Sebastian Bach", source: "Skid Row", inImage: false },
    { name: "Gary Moore", officialName: "Gary Moore", source: "Gary Moore", inImage: false },
    { name: "Kenny Wayne Shepherd", officialName: "Kenny Wayne Shepherd", source: "Kenny Wayne Shepherd Band", inImage: false },
    { name: "Joe Bonamassa", officialName: "Joe Bonamassa", source: "Joe Bonamassa", inImage: false },
    { name: "Jack White", officialName: "Jack White", source: "The White Stripes", inImage: false },

    // 1950-1962 early rock 'n' roll decoys
    { name: "Elvis Presley", officialName: "Elvis Presley", source: "Elvis Presley", inImage: false },
    { name: "Chuck Berry", officialName: "Chuck Berry", source: "Chuck Berry", inImage: false },
    { name: "Little Richard", officialName: "Little Richard", source: "Little Richard", inImage: false },
    { name: "Buddy Holly", officialName: "Buddy Holly", source: "Buddy Holly and the Crickets", inImage: false },
    { name: "Jerry Lee Lewis", officialName: "Jerry Lee Lewis", source: "Jerry Lee Lewis", inImage: false },
    { name: "Bo Diddley", officialName: "Bo Diddley", source: "Bo Diddley", inImage: false },
    { name: "Fats Domino", officialName: "Fats Domino", source: "Fats Domino", inImage: false },
    { name: "Eddie Cochran", officialName: "Eddie Cochran", source: "Eddie Cochran", inImage: false },
    { name: "Carl Perkins", officialName: "Carl Perkins", source: "Carl Perkins", inImage: false },
    { name: "Gene Vincent", officialName: "Gene Vincent", source: "Gene Vincent and His Blue Caps", inImage: false },

    // 1972-1980 classic rock decoys
    { name: "Brian May", officialName: "Brian May", source: "Queen", inImage: false },
    { name: "Roger Taylor", officialName: "Roger Taylor", source: "Queen", inImage: false },
    { name: "Mark Knopfler", officialName: "Mark Knopfler", source: "Dire Straits", inImage: false },
    { name: "Jeff Lynne", officialName: "Jeff Lynne", source: "Electric Light Orchestra", inImage: false },
    { name: "Steve Howe", officialName: "Steve Howe", source: "Yes", inImage: false },
    { name: "Chris Squire", officialName: "Chris Squire", source: "Yes", inImage: false },
    { name: "Tom Scholz", officialName: "Tom Scholz", source: "Boston", inImage: false },
    { name: "Steve Walsh", officialName: "Steve Walsh", source: "Kansas", inImage: false },
    { name: "Rick Nielsen", officialName: "Rick Nielsen", source: "Cheap Trick", inImage: false },
    { name: "Steven Tyler", officialName: "Steven Tyler", source: "Aerosmith", inImage: false },
    { name: "Joe Perry", officialName: "Joe Perry", source: "Aerosmith", inImage: false },
    { name: "Paul Rodgers", officialName: "Paul Rodgers", source: "Bad Company", inImage: false },
    { name: "Billy Gibbons", officialName: "Billy Gibbons", source: "ZZ Top", inImage: false },
    { name: "Geddy Lee", officialName: "Geddy Lee", source: "Rush", inImage: false },
    { name: "Alex Lifeson", officialName: "Alex Lifeson", source: "Rush", inImage: false },
    { name: "Neil Peart", officialName: "Neil Peart", source: "Rush", inImage: false },
    { name: "Randy Bachman", officialName: "Randy Bachman", source: "Bachman-Turner Overdrive", inImage: false },
    { name: "Ian Hunter", officialName: "Ian Hunter", source: "Mott the Hoople", inImage: false },
    { name: "Bryan Ferry", officialName: "Bryan Ferry", source: "Roxy Music", inImage: false },
    { name: "Suzi Quatro", officialName: "Suzi Quatro", source: "Suzi Quatro", inImage: false }
];